import { Clock, Rocket, Mail, Phone } from "lucide-react";

// ⚠️ CAMBIAR A false CUANDO PAGUEN PARA DESACTIVAR EL BLOQUEO
export const ACTIVATION_LOCKED = false;

export default function ActivationLock() {
  if (!ACTIVATION_LOCKED) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-[#1C1917] via-[#292524] to-[#1C1917] flex items-center justify-center">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="relative text-center px-8 max-w-2xl mx-auto">
        {/* Animated Icon */}
        <div className="mb-8 relative">
          <div className="w-32 h-32 mx-auto bg-gradient-to-br from-[#F9A825] to-[#FF8F00] rounded-full flex items-center justify-center animate-pulse shadow-2xl shadow-[#F9A825]/30">
            <Rocket className="w-16 h-16 text-white" />
          </div>
          <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
            <div className="flex items-center gap-1 bg-[#F9A825] text-black px-4 py-1 rounded-full text-sm font-bold">
              <Clock className="w-4 h-4" />
              EN PROCESO
            </div>
          </div>
        </div>

        {/* Main Title */}
        <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight">
          Esperando
          <span className="block text-[#F9A825]">Despliegue Final</span>
        </h1>

        {/* Description */}
        <p className="text-xl md:text-2xl text-white/70 mb-12 leading-relaxed">
          El sistema está listo y configurado.<br />
          La activación se completará una vez confirmado el proceso.
        </p>

        {/* Status Card */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 mb-8">
          <h3 className="text-white font-semibold text-lg mb-4">Estado del Sistema</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-green-500/20 rounded-xl p-4">
              <div className="w-3 h-3 bg-green-500 rounded-full mx-auto mb-2 animate-pulse"></div>
              <p className="text-green-400 text-sm font-medium">Backend</p>
              <p className="text-green-300 text-xs">Operativo</p>
            </div>
            <div className="bg-green-500/20 rounded-xl p-4">
              <div className="w-3 h-3 bg-green-500 rounded-full mx-auto mb-2 animate-pulse"></div>
              <p className="text-green-400 text-sm font-medium">Frontend</p>
              <p className="text-green-300 text-xs">Operativo</p>
            </div>
            <div className="bg-green-500/20 rounded-xl p-4">
              <div className="w-3 h-3 bg-green-500 rounded-full mx-auto mb-2 animate-pulse"></div>
              <p className="text-green-400 text-sm font-medium">Base de Datos</p>
              <p className="text-green-300 text-xs">Operativo</p>
            </div>
            <div className="bg-yellow-500/20 rounded-xl p-4">
              <div className="w-3 h-3 bg-yellow-500 rounded-full mx-auto mb-2 animate-pulse"></div>
              <p className="text-yellow-400 text-sm font-medium">Activación</p>
              <p className="text-yellow-300 text-xs">Pendiente</p>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="text-white/50 text-sm">
          <p className="mb-2">¿Consultas sobre la activación?</p>
          <div className="flex items-center justify-center gap-6">
            <a href="mailto:contacto@servicioscatalina.cl" className="flex items-center gap-2 hover:text-[#F9A825] transition-colors">
              <Mail className="w-4 h-4" />
              contacto@servicioscatalina.cl
            </a>
          </div>
        </div>

        {/* Servicios Catalina Branding */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-white/30 text-sm">
            Servicios Catalina © 2025
          </p>
        </div>
      </div>
    </div>
  );
}
